import React, { Component } from 'react';
import RaisedButton from 'material-ui/RaisedButton';
import muiThemeable from 'material-ui/styles/muiThemeable';
import TextField from 'material-ui/TextField';

import HomeGalleryHeader from './HomeGalleryHeader';
import HomeGalleryFooter from './HomeGalleryFooter';
import HeroSection from './HeroSection';

import firebase from './firebase';

const SectionDivider = (props) => (
  <hr style={{ borderTop: "1px solid #d9d9d9",
               margin: "10px auto",
               width: props.width? props.width : "75%" }} />
)

const SectionHeader = muiThemeable()((props) => (
  <div style={{
      marginBottom: "10px",
      fontSize: "25px"
    }}>
    {props.children}
  </div>
));

function LikeModule(props) {
  return (
    <div>
      {props.artworkSnapshot &&
        <div style={{
            marginTop: "40px",
            maxWidth:'90%',
            width: '400px',
            marginLeft: 'auto',
            marginRight: 'auto',
          }}>
          <img alt="artwork example" src={props.artworkSnapshot.image_urls[0]} style={{
              maxHeight:'200px',
              width: 'auto',
              height: 'auto',
              boxShadow: "1px 1px 2px #888888",
            }}></img>
          <div style={{marginTop: "10px", fontSize: "20px"}}>{props.artworkSnapshot.title}</div>
          <div hidden={!props.infiniteMessageShown} style={{
              color: "#AAAAAA"
            }}>Hey! Thanks for telling us what you like. Feel free to continue, or stop whenever.</div>
          <div>
            <RaisedButton primary={true}
              style={{
                margin: "1em",
                width: "110px",
              }}
              onClick={() => props.choiceCallback("Skip")}
              label="Skip"></RaisedButton>
            <RaisedButton primary={true}
              style={{
                margin: "1em",
                width: "110px",
              }}
              onClick={() => props.choiceCallback("Like")}
              label="Like"></RaisedButton>
          </div>
        </div>
      }
    </div>
  );
}

class HistoryEntryController extends Component {
  state = {
    artwork: null,
  }

  componentDidMount() {
    if (!this.props.historyItem) {
      return;
    }

    this.artworkRef = firebase.database().ref().child('artwork').child(this.props.historyItem.value.artwork);
    this.artworkListener = this.artworkRef.on('value',
      (snapshot) => {
        this.setState({artwork: snapshot.val()});
      }
    );
  }

  render() {
    if (this.state.artwork && (this.props.showSkips || (this.props.historyItem.value.choice === "Like"))) {
      return <HistoryEntry historyItem={this.props.historyItem} artwork={this.state.artwork} />
    } else {
      return null;
    }
  }
}



const HistoryModule = muiThemeable()((props) => (
  <div style={{
      backgroundColor: props.muiTheme.palette.alternate3Color,
      paddingTop: "20px",
      paddingBottom: "20px",
    }}>
    <SectionHeader>History</SectionHeader>
    <div>Likes Only (<a onClick={props.toggleShowSkips}>{props.showSkips ? "hide" : "show"} skips</a>)</div>
    { props.historyItems.map((item) =>
      <HistoryEntryController key={item.key} historyItem={item} showSkips={props.showSkips} />
    ).reverse()}
  </div>
));

function likeSpan(undoCallback) {
  return <span>
    <span style={{
        color: "#388E3C" // green 700
      }}>Liked</span>&nbsp;-&nbsp;
      <span style={{textDecoration: 'underline'}}
             onClick={undoCallback}>undo</span>
  </span>
}

function skipSpan(undoCallback) {
    return <span>
      <span style={{
          color: "#d32f2f" // red 700
        }}>Skipped</span>&nbsp;-&nbsp;
        <span style={{textDecoration: 'underline'}}
               onClick={undoCallback}>undo</span>
    </span>
}


function HistoryEntry(props) {
  function undoLikeCallback() {
    props.historyItem.ref.child('choice').set('Skip');
  }

  function undoSkipCallback() {
    props.historyItem.ref.child('choice').set('Like');
  }
  return (
    <div style={{margin: 'auto', width: '400px', maxWidth: '90%'}}>
      <img alt="artwork" src={props.artwork.image_urls[0]} style={{
          maxWidth:'90%',
          maxHeight:'300px',
          width: 'auto',
          height: 'auto',
          boxShadow: "1px 1px 2px #888888",
          margin: "10px auto",
        }}></img>
      <div style={{fontSize: "20px"}}>{props.artwork.title}</div>
      <div>{props.historyItem.value.choice === "Like" ? likeSpan(undoLikeCallback) : skipSpan(undoSkipCallback) }</div>
      <div>
        <TextField
          name={props.historyItem.ref.key}
          value={props.historyItem.value.comment || ""}
          floatingLabelText={"What do you " + (props.historyItem.value.choice === "Like" ? "like" : "dislike") + "?"}
          onChange={(event, newValue) => {props.historyItem.ref.child("comment").set(newValue)}}
        />
      </div>
      <SectionDivider />
    </div>
  );
}


const TastemakerPage = muiThemeable()(class extends Component {
  state = {
    user: null,
    artwork_id: null,
    artwork_snapshot: null,
    score: null,
    choicesBeforeInfiniteMessageShown: 20,
    historyItems: [],
    showSkips: false,
  }

  getNextArtwork() {
    console.log('getNextArtwork');
    if (!this.state.user) {
      return;
    }

    var startAt = this.state.artwork_id
      || (this.state.user.tastemaker && this.state.user.tastemaker.last_artwork_id);
    console.log("starting at " + startAt);

    var query = null;
    if (startAt) {
      query = this.artworkRef.orderByKey().startAt(startAt).limitToFirst(2)
    } else {
      query = this.artworkRef.orderByKey().startAt("-Kg3U5UMPSYWbyvK7ARQ").limitToFirst(1)
    }
    query.once('value',
      (snapshot) => {
        console.log(snapshot.val());
        for (var key in snapshot.val()) {
          if (snapshot.val().hasOwnProperty(key)) {
            console.log(key);
            if (key !== this.state.artwork_id) {
              this.setState({
                artwork_snapshot: snapshot.child(key).val(),
                artwork_id: key,
              });
            }
          }
        }
      }
    );
  }


  componentDidMount() {
    this.artworkRef = firebase.database().ref().child('artwork');

    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        this.userRef = firebase.database().ref().child('users').child(user.uid);
        this.listener = this.userRef.on('value',
          (snapshot) => {
            this.setState({user: snapshot.val()});
          }
        );

        this.historyListenerRef = this.userRef.child('tastemaker/history');
        this.historyListenerRef.on('child_added', snap => {
            const historyItem = {
                key: snap.key,
                ref: snap.ref,
                value: snap.val()
            };
            this.setState(previousState => {
                previousState.historyItems.push(historyItem);
                return { historyItems: previousState.historyItems };
            });
        });
        this.historyListenerRef.on('child_changed', snap => {
          const newHistoryItem = {
              key: snap.key,
              ref: snap.ref,
              value: snap.val()
          };

          var change_item = function(historyItems, newHistoryItem) {
            for (var i=0; i<historyItems.length; i++) {
              if (historyItems[i].key === snap.key) {
                historyItems.splice(i, 1, newHistoryItem);
                return historyItems;
              }
            }
          };

          this.setState(previousState => {
            var newHistoryItems = change_item(previousState.historyItems, newHistoryItem);
            return { historyItems: newHistoryItems }; 
          });
        });
        this.historyListenerRef.on('child_removed', snap => {
          function remove_item(historyItems, key) {
            for (var i=0; i<historyItems.length; i++) {
              if (historyItems[i].key === key) {
                historyItems.splice(i, 1);
                return historyItems
              }
            }
          }
            this.setState(previousState => {
              var newHistoryItems = remove_item(previousState.historyItems, snap.key);
              return { historyItems: newHistoryItems };
            });
        });

      } else {
        this.setState({user: null});
        document.location="/login?next=/tastemaker";
      }
    }, function(error) {
      console.log(error);
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if ('user' in this.state && this.state.artwork_id === null) {
      this.getNextArtwork();
    }
  }

  makeChoice = (choice) => {
    // change guessRef to be away from /users/ to prevent a slowdown required by getting user data when a choice is updated
    var guessRef = this.userRef.child('tastemaker/history').push();
    guessRef.set({
      artwork: this.state.artwork_id,
      choice: choice,
      timestamp: firebase.database.ServerValue.TIMESTAMP,
    });

    this.userRef.child('tastemaker/last_artwork_id').set(this.state.artwork_id);
    this.getNextArtwork();

    this.setState((prevState, props) => {
      return {choicesBeforeInfiniteMessageShown: prevState.choicesBeforeInfiniteMessageShown-1}
    });
  }

  toggleShowSkips = () => {
    this.setState((prevState, props) => { return {showSkips: !prevState.showSkips}});
  }

  render() {
    return this.state.user &&
       <div>
         <HomeGalleryHeader />

         <div style={{
             margin: 'auto',
             textAlign: 'center',
             fontWeight: 'normal',
             backgroundColor: this.props.muiTheme.palette.canvasColor,
             fontFamily: "'Roboto', sans-serif",
           }}>
           <HeroSection
             header="Like or skip each artwork to show your curator your tastes." />
           <LikeModule choiceCallback={this.makeChoice} artworkSnapshot={this.state.artwork_snapshot} infiniteMessageShown={this.state.choicesBeforeInfiniteMessageShown <= 0} />
           { this.userRef && this.state.user.tastemaker &&
             <HistoryModule
               historyItems={this.state.historyItems}
               showSkips={this.state.showSkips}
               toggleShowSkips={this.toggleShowSkips}
               />
           }
          </div>
         <HomeGalleryFooter />
       </div>
  }
});

export default TastemakerPage;



// WEBPACK FOOTER //
// ./src/TastemakerPage.js